// Toast types
export enum toastTypes {
  DEFAULT = 'default',
  SUCCESS = 'success',
  WARNING = 'warning',
}

// Color enums
export enum containerColors {
  DEFAULT = '#00000085',
  SUCCESS = '#A7E8DD',
  WARNING = '#FFE2BF',
}
export enum fontColors {
  DEFAULT = '#FFFFFF',
  SUCCESS = '#28695D',
  WARNING = '#900504',
}

// Toaster configurations
export interface ToastBannerConfig {
  type: string;
  containerColor: string;
  fontColor: string;
}

export const SUCCESS_TOASTER: ToastBannerConfig = {
  type: toastTypes.SUCCESS,
  containerColor: containerColors.SUCCESS,
  fontColor: fontColors.SUCCESS,
};
export const WARNING_TOASTER: ToastBannerConfig = {
  type: toastTypes.WARNING,
  containerColor: containerColors.WARNING,
  fontColor: fontColors.WARNING,
};
export const DEFAULT_TOASTER: ToastBannerConfig = {
  type: toastTypes.DEFAULT,
  containerColor: containerColors.DEFAULT,
  fontColor: fontColors.DEFAULT,
};
